import axiosInstance from "@/service/AxiosInstance";

import {
  DELETE_RATIO_MUTATION,
  DELETE_RATIO_ACTION,
  SEARCH_RATIO_ACTION,
  SEARCH_RECEIPT_RATIO_ACTION,
  EDIT_RECEIPT_RATIO_MUTATION,
  EDIT_RECEIPT_RATIO_ACTION,
  RESET_ALL_DEALER_RECEIPT_ACTION,
  ADD_RECEIPT_RATIO_MUTATION,
  ADD_RECEIPT_RATIO_ACTION,
  POST_RETURN_RATIO_MUTATION,
  POST_RETURN_RATIO_ACTION,
  GET_RATIO_CLIENT_DETAIL_MUTATION,
  GET_RATIO_CLIENT_DETAIL_ACTION,
  GET_RATIO_CLIENT_MUTATION,
  GET_RATIO_CLIENT_ACTION,
  POST_RATIO_ACTION,
  POST_RATIO_MUTATION,
  GET_RATIO_MUTATION,
  GET_RATIO_ACTION,
  GET_DEALER_REPORT_ACTION,
  GET_DEALER_REPORT_MUTATION,
  RESET_RATIO_Action,
  RESET_DEALER_REPORT_Action,
  GET_DEALER_PROFIT_ACTION,
  GET_DEALER_PROFIT_MUTATION,
  GET_ALL_DEALER_PROFIT_ACTION,
  GET_ALL_DEALER_PROFIT_MUTATION,
  GET_ALL_DEALER_RECEIPT_ACTION,
  GET_ALL_DEALER_RECEIPT_MUTATION,
  BASE_URL,
} from "@/store/storeConstants";
export default {
  async [GET_RATIO_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/ratio/index?start_date=${payload.startDate}&end_date=${payload.endDate}&client_id=${payload.clientId}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }
    if (response.status == 200) {
      console.log(response.data);
      let finalRatio =
        parseInt(response.data.totalRatio) +
        parseInt(response.data.totalProtaction) -
        parseInt(response.data.totalDiscount);
      let data = {
        loaded: true,
        ratios: response.data.data,
        totalRatio: response.data.totalRatio,
        totalProtaction: response.data.totalProtaction,
        totalDiscount: response.data.totalDiscount,
        totalBonus: response.data.totalBonus,
        finalRatio: finalRatio,
        countOrderReturn: response.data.countOrderReturn,
        countOrderDone: response.data.countOrderDone,
      };

      context.commit(GET_RATIO_MUTATION, data);
    }
  },

  async [GET_DEALER_REPORT_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/order/dealer/report?start_date=${payload.startDate}&end_date=${payload.endDate}&dealer_id=${payload.dealerId}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }
    if (response.status == 200) {
      let finalRatio =
        parseInt(response.data.totalRatio) +
        parseInt(response.data.totalProtaction) -
        parseInt(response.data.totalDiscount);
      let data = {
        loaded: true,
        result: response.data.data,
        totalRatioResult: response.data.totalRatio,
        totalProtactionResult: response.data.totalProtaction,
        totalDiscountResult: response.data.totalDiscount,
        finalRatioResult: finalRatio,
        countOrderReturnResult: response.data.countOrderReturn,
        countOrderDoneResult: response.data.countOrderDone,
      };

      context.commit(GET_DEALER_REPORT_MUTATION, data);
    }
  },

  async [GET_ALL_DEALER_RECEIPT_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/order/dealer/payments?dealer_id=${payload.dealerId}&start_date=${payload.startDate}&end_date=${payload.endDate}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }
    if (response.status == 200) {
      let data = {
        loaded: true,
        payments: response.data.payments,
        total: response.data.total,
      };
      context.commit(GET_ALL_DEALER_RECEIPT_MUTATION, data);
    }
  },

  async [RESET_ALL_DEALER_RECEIPT_ACTION](context, payload) {
    let data = {
      loaded: true,
      payments: [],
      total: 0,
    };
    context.commit(GET_ALL_DEALER_RECEIPT_MUTATION, data);
  },

  async [GET_ALL_DEALER_PROFIT_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/order/dealer/all_profit?start_date=${payload.startDate}&end_date=${payload.endDate}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      console.log(response.data);

      const totalAllDealerProfit = response.data.dealersProfits.reduce(
        (sum, item) => sum + Number(item.total_profit || 0),
        0,
      );
      let data = {
        loaded: true,
        allDealerProfit: response.data,
        totalAllDealerProfit: totalAllDealerProfit,
      };

      context.commit(GET_ALL_DEALER_PROFIT_MUTATION, data);
    }
  },

  async [GET_DEALER_PROFIT_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/order/dealer/profit?start_date=${payload.startDate}&end_date=${payload.endDate}&dealer_id=${payload.dealerId}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }
    if (response.status == 200) {
      let data = {
        loaded: true,
        totalProfit: response.data.totalProfit,
        countOrderReturnResult: response.data.countOrderReturn,
        countOrderDoneResult: response.data.countOrderDone,
      };

      context.commit(GET_DEALER_PROFIT_MUTATION, data);
    }
  },

  async [POST_RATIO_ACTION](context, payload) {
    context.commit(POST_RATIO_MUTATION, true);

    let response = "";
    try {
      response = await axiosInstance.post(
        `${BASE_URL}/app/ratio/create`,
        payload,
      );
    } catch (error) {
      context.commit(POST_RATIO_MUTATION, false);
      if ((error.response.status = 408)) throw error.response.data.message;
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      console.log(response.data);
      context.commit(POST_RATIO_MUTATION, false);
    }
  },

  async [POST_RETURN_RATIO_ACTION](context, payload) {
    context.commit(POST_RETURN_RATIO_MUTATION, true);

    let response = "";
    try {
      response = await axiosInstance.post(
        `${BASE_URL}/app/ratio/return`,
        payload,
      );
    } catch (error) {
      context.commit(POST_RETURN_RATIO_MUTATION, false);
      if ((error.response.status = 408)) throw error.response.data.message;
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      console.log(response.data);
      context.commit(POST_RETURN_RATIO_MUTATION, false);
    }
  },

  async [ADD_RECEIPT_RATIO_ACTION](context, payload) {
    context.commit(ADD_RECEIPT_RATIO_MUTATION, true);

    let response = "";
    try {
      response = await axiosInstance.post(
        `${BASE_URL}/app/ratio/receipt/add`,
        payload,
      );
    } catch (error) {
      context.commit(ADD_RECEIPT_RATIO_MUTATION, false);
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      console.log(response.data);
      context.commit(ADD_RECEIPT_RATIO_MUTATION, false);
    }
  },

  async [EDIT_RECEIPT_RATIO_ACTION](context, payload) {
    context.commit(EDIT_RECEIPT_RATIO_MUTATION, true);

    let response = "";
    try {
      response = await axiosInstance.post(
        `${BASE_URL}/app/ratio/receipt/edit`,
        payload,
      );
    } catch (error) {
      context.commit(EDIT_RECEIPT_RATIO_MUTATION, false);
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      console.log(response.data);
      context.commit(EDIT_RECEIPT_RATIO_MUTATION, false);
    }
  },

  async [GET_RATIO_CLIENT_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/ratio/all?page=${payload.currentPage}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }

    if (response.status == 200) {
      const data = {
        allRatios: response.data.data,
        allRatioLoaded: true,
      };
      context.commit(GET_RATIO_CLIENT_MUTATION, data);
    }
  },

  async [SEARCH_RECEIPT_RATIO_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/ratio/all?receipt=${payload.text}`,
      );
    } catch (error) {
      console.log(error);
      return error;
    }
    if (response.status == 200) {
      console.log(response.data);
      const data = {
        allRatios: response.data.data,
        allRatioLoaded: true,
      };
      context.commit(GET_RATIO_CLIENT_MUTATION, data);
    }
  },

  async [GET_RATIO_CLIENT_DETAIL_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/ratio/detail/${payload.id}?page=${payload.currentPage}`,
      );
    } catch (error) {
      console.log(error);

      context.commit(GET_RATIO_CLIENT_DETAIL_MUTATION);
      return error;
    }

    if (response.status == 200) {
      const data = {
        ratioDetails: response.data.data,
        ratioDetailsLoaded: true,
      };
      context.commit(GET_RATIO_CLIENT_DETAIL_MUTATION, data);
    }
  },

  async [SEARCH_RATIO_ACTION](context, payload) {
    let response = "";
    try {
      response = await axiosInstance.get(
        `${BASE_URL}/app/ratio/detail/${payload.id}?ratio=${payload.text}`,
      );
    } catch (error) {
      console.log(error);

      return error;
    }

    if (response.status == 200) {
      console.log(response.data);
      const data = {
        ratioDetails: response.data.data,
        ratioDetailsLoaded: true,
      };
      context.commit(GET_RATIO_CLIENT_DETAIL_MUTATION, data);
    }
  },

  async [RESET_RATIO_Action](context, payload) {
    let data = {
      loaded: false,
      ratios: [],
      totalRatio: 0,
      totalProtaction: 0,
      totalDiscount: 0,
      totalBonus: 0,
      finalRatio: 0,
      countOrderReturn: 0,
      countOrderDone: 0,
    };

    context.commit(GET_RATIO_MUTATION, data);
  },

  async [RESET_DEALER_REPORT_Action](context, payload) {
    let data = {
      loaded: false,
      result: [],
      totalRatioResult: 0,
      totalProtactionResult: 0,
      totalDiscountResult: 0,
      finalRatioResult: 0,
      countOrderReturnResult: 0,
      countOrderDoneResult: 0,
    };

    context.commit(GET_DEALER_REPORT_MUTATION, data);
  },

  async [DELETE_RATIO_ACTION](context, payload) {
    context.commit(DELETE_RATIO_MUTATION, true);
    const id = payload.ratioId;
    let response = "";
    try {
      response = await axiosInstance.delete(
        `${BASE_URL}/app/ratio/delete/${id}`,
      );
    } catch (e) {
      context.commit(DELETE_RATIO_MUTATION, false);
    }

    if ((response.status = 200)) {
      context.commit(DELETE_RATIO_MUTATION, false);
    }
  },
};
